import { Component, OnInit, input, ChangeDetectionStrategy } from '@angular/core';
import { Player } from 'ngx-sport';
import { ImageRepository } from '../../lib/image/repository';
import { LineIconComponent } from '../../shared/commonmodule/lineicon/lineicon.component';
import { TeamNameComponent } from '../team/name.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: "app-player-basics",
  standalone: true,
  imports: [LineIconComponent, TeamNameComponent, FontAwesomeModule],
  templateUrl: "./basics.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./basics.component.scss"],
})
export class PlayerBasicsComponent implements OnInit {
  readonly player = input<Player>();
  readonly points = input<number>();
  readonly card = input(false);
  public faUserCircle = faUserCircle;

  constructor(public imageRepository: ImageRepository) {}

  ngOnInit() {}

  //OnChanges player, points

  getTeamImageUrl(player: Player): string {
    return this.imageRepository.getTeamUrl(player.getTeam());
  }

  getPlayerImageUrl(player: Player): string {
    return this.imageRepository.getPlayerUrl(player);
  }
}
